import React from  'react'
import documentOutlineWhite from '../assets/icons/documentOutlineWhite.svg'

const FileAttachment = (props) => {

    const imageAttachmentStyle = {
        padding: "10px",
        verticalAlign: "middle",
        fontFamily: "Gotham",
        fontSize: "16px"
    }

    return (
        <div style={imageAttachmentStyle}>
           <img style={{ paddingRight: "10px"}} src={documentOutlineWhite} alt="File Icon"/> {props.fileName} - {props.fileSize} {props.sizeType}
        </div>
    );
}

export default FileAttachment